import React from 'react';
import Progress from './progress';

const Footer = ({ left, right, step, totalSteps }) => {
  return (
    <div className="card-footer">
      <div className="row">
        <div className="col-6 col-sm-4">{left}</div>
        <div className="col-4 d-none d-sm-block">
          <Progress step={step} totalSteps={totalSteps} />
        </div>
        <div className="col-6 col-sm-4">{right}</div>
      </div>
      <div className="row d-sm-none mt-3">
        <div className="col-12">
          <Progress step={step} totalSteps={totalSteps} />
        </div>
      </div>
    </div>
  );
};

export default Footer;
